import type React from "react";
import { memo } from "react";
import { useTablistNavigation } from "../hooks/useTablistNavigation";

interface MobileNavProps {
	activeTab: "transcript" | "comments";
	onTabChange: (tab: "transcript" | "comments") => void;
}

const MOBILE_TABS = ["transcript", "comments"] as const;

/**
 * Mobile navigation component, memoized to prevent re-renders when other state changes.
 */
export const MobileNav: React.FC<MobileNavProps> = memo(
	({ activeTab, onTabChange }) => {
		const { getTabProps } = useTablistNavigation({
			tabs: MOBILE_TABS,
			activeTab,
			onChange: onTabChange,
		});

		return (
			<div
				id="mobile-tabs"
				className="hidden max-[600px]:flex bg-card-bg border-b border-border-main px-4"
				role="tablist"
				aria-label="表示切り替え"
			>
				<button
					type="button"
					id="mobile-tab-transcript"
					role="tab"
					aria-controls="mobile-panel-transcript"
					{...getTabProps("transcript")}
					className={`flex-1 py-4 bg-transparent border-none border-b-2 font-semibold text-sm cursor-pointer transition-all duration-200 focus-visible:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary active:scale-95 ${
						activeTab === "transcript"
							? "text-primary border-primary"
							: "text-text-dim border-transparent"
					}`}
					onClick={() => onTabChange("transcript")}
				>
					文字起こし
				</button>
				<button
					type="button"
					id="mobile-tab-comments"
					role="tab"
					aria-controls="mobile-panel-comments"
					{...getTabProps("comments")}
					className={`flex-1 py-4 bg-transparent border-none border-b-2 font-semibold text-sm cursor-pointer transition-all duration-200 focus-visible:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary active:scale-95 ${
						activeTab === "comments"
							? "text-primary border-primary"
							: "text-text-dim border-transparent"
					}`}
					onClick={() => onTabChange("comments")}
				>
					AIコメント
				</button>
			</div>
		);
	},
);
